export default __webpack_public_path__ + "static/media/f9b28a86cf4c18e92a6c64e059e81e1f1599168695833.1fbefda2.webp";